import * as React from 'react';
import {LocalParamList} from '../../../../../shared/components/tabBar/components/types';
import View from './view';
import {useModifiedRouterParams} from '../../../../../shared/hooks/routeParams';
import {useModal} from '../../../../../shared/components/modal';
import {NavigationHelpers, useNavigation} from '@react-navigation/native';
import {ProfileApplicationsItemDesktop} from './item';
import {ApplicationsProps} from '../../../common/applications/model';
import {ProfileApplicationsItemResolver} from '../../../../../shared/resolvers/applications';
import {VisImpStatus} from '../../../../../shared/models/visuallyImpairedSettings';
import {useSelector} from 'react-redux';
import {themeSelector} from '../../../../../redux/selectors/runtime/theme';

export const ProfileDesktopApplications: React.FC<ApplicationsProps> = (props) => {
  const modal = useModal();
  const nav = useNavigation() as unknown as NavigationHelpers<LocalParamList>;
  const visuallyImpairedState = useSelector(themeSelector());

  useModifiedRouterParams<{'application-id': string}>((params) => {
    if (params['application-id']) {
      modal.show({
        render(modalParams, methods) {
          const hideModal = () => {
            methods.remove(modalParams.id);
            // nav.navigate(Screens.ProfileApplications, {'application-id': ''});
            nav.setParams({'application-id': ''});
          };

          return React.createElement(ProfileApplicationsItemResolver(ProfileApplicationsItemDesktop), {
            navigation: nav,
            onClose: hideModal,
            route: {params} as any,
          });
        },
      });
    }
  });

  return View({
    ...props,
    isVisuallyImpaired: visuallyImpairedState?.visuallyImpaired === VisImpStatus.Active,
  });
};
